module.exports = __webpack_public_path__ + "static/media/Autoridades.85980287.jpg";